const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/teams/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { MONTH, QUARTER, YEAR } from '@/components/loop-teams/types';
const indexSearchSchema = z.object({
  period: z.enum([MONTH, QUARTER, YEAR]).optional().default(MONTH)
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/teams/')({
  validateSearch: zodValidator(indexSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});